// extracted by mini-css-extract-plugin
export default {"header":"InvestigationHeader_header__ecifx","actions":"InvestigationHeader_actions__X060V"};